// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12BqW","index":"styles_index__20Jc5"};